import { useAuth } from "src/hook/useContext";
import { useRoleAuth } from "src/hook/useRoleAuth";
import { ChildrenContent } from "src/shared/interface/props/childrenContent";

interface Props extends ChildrenContent {
  requiredRoles?: string[];
}

export const ProtectedRoute = ({ children, requiredRoles }: Props) => {
  const { user } = useAuth();
  if (!user) {
    window.location.href = '/login'
  }
  const authSign = useRoleAuth(requiredRoles as string[]);
  return <> { authSign && children } </>;
};
